var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1330.38 -512.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1338.97,533.88a1.91,1.91,0,0,1-1.89,1.9h-.01a1.9,1.9,0,1,1,1.9-1.9Z",
    transform: "translate(-0.247 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1350.97,533.88a1.9,1.9,0,1,1-1.9-1.9A1.906,1.906,0,0,1,1350.97,533.88Z",
    transform: "translate(-0.99 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1346.6,524.262a1.809,1.809,0,0,0,1.579-.922l4.115-7.332a.585.585,0,0,0,.086-.311.672.672,0,0,0-.191-.471.679.679,0,0,0-.479-.188h-17.282l-1.081-2.259h-2.967V514.1h2.115l4.373,9.054-1.675,2.974a1.766,1.766,0,0,0,.038,1.779,1.814,1.814,0,0,0,1.55.875h13.311v-1.318h-14.115l1.789-3.2Zm-11.531-7.906h15.512l-3.7,6.588h-8.641Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.08f6a961194de8dba4e0025d33572394.svg";
export { ForwardRef as ReactComponent };